/**
 * <announcement-bar data-autoplay="5">
 * Shows one message at a time. Rotates on a timer when `data-autoplay` holds a
 * number of seconds, and pauses while the pointer or keyboard focus is on the bar.
 * Does not rotate by itself for people who asked their device for less motion.
 */
class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.index = 0;
    this.show(0);
    this.classList.add('is-ready');
    if (this.slides.length < 2) return;

    this.querySelector('[data-previous]')?.addEventListener('click', () => this.step(-1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));

    const seconds = Number(this.dataset.autoplay);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seconds > 0 && !reducedMotion) {
      this.delay = seconds * 1000;
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.step(1), this.delay);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  step(direction) {
    this.show((this.index + direction + this.slides.length) % this.slides.length);
  }

  show(index) {
    this.index = index;
    this.slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('is-active', active);
      slide.toggleAttribute('inert', !active);
    });
  }
}

if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);
